type CajaCerradaNoticeHandler = (message: string) => Promise<void>;

let noticeHandler: CajaCerradaNoticeHandler | null = null;

export function registerCajaCerradaNoticeHandler(
  handler: CajaCerradaNoticeHandler
): () => void {
  noticeHandler = handler;
  return () => {
    if (noticeHandler === handler) {
      noticeHandler = null;
    }
  };
}

export async function requestCajaCerradaNotice(message: string): Promise<void> {
  if (noticeHandler) {
    await noticeHandler(message);
    return;
  }

  window.alert(
    `${message}\n\nSerá redirigido para seleccionar y abrir una caja.`
  );
}
